import {AfterViewInit, Component, ElementRef, Input, OnInit, Renderer2, ViewEncapsulation} from '@angular/core';
import {createCanvas} from 'canvas';
import cloud from 'd3-cloud';
import * as d3 from 'd3';
import {NgClass, NgIf, NgStyle} from '@angular/common';

@Component({
  selector: 'app-word-cloud',
  templateUrl: './word-cloud.component.html',
  styleUrls: ['./word-cloud.component.scss'],
  standalone: true,
  imports: [NgStyle, NgClass, NgIf],
  encapsulation: ViewEncapsulation.None
})
export class WordCloudComponent implements OnInit, AfterViewInit {
  @Input() phrases: any;

  svg = null;

  words = [];

  width = 600;
  height = 400;

  palette =  [
    '#4CEB96', // Light green
    '#6EFAAC', // Minty green
    '#8DFFC4', // Very light green
    '#C0BBFD', // Pastel purple
    '#D4CEFF', // Light lavender
    '#8489B2', // Additional color with moderate saturation
    '#B8E0FF', // Light sky blue for added variety
    '#FFE4FA', // Light pink
    '#FAD1F2', // Soft rosy pink
    '#FFFFE5', // Soft yellow
    '#C3FFD5', // Soft lime
    '#E0FFF5', // Light aquamarine
    '#FFF3E1', // Creamy peach
    '#FAFFD3'  // Light lemon
  ];

  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
  ) {
  }

  ngOnInit() {

  }

  ngAfterViewInit() {
    this.width = this.el.nativeElement.offsetWidth || this.width;
    this.generateWordCloud();
  }

  getRandomColor() {
    const randomIndex = Math.floor(Math.random() * this.palette.length);
    return this.palette[randomIndex];
  }

  draw(words) {
    const svg = d3.create('svg');
    svg
      .attr('width', this.width)
      .attr('height', this.height)
      .attr('viewBox', '0 0 ' + this.width + ' ' + this.height)
      .append('g')
      .attr('transform', 'translate(' + this.width / 2 + ',' + this.height / 2 + ')')
      .selectAll('text')
      .data(words)
      .enter().append('text')
      .style('font-size', function(d) {
        return d.size + 'px';
      })
      .style('font-family', 'Impact')
      .style('fill', () => this.getRandomColor())
      .attr('text-anchor', 'middle')
      .attr('transform', function(d) {
        return 'translate(' + [d.x, d.y] + ')rotate(' + d.rotate + ')';
      })
      .text(function(d) {
        return d.text;
      });

    return svg.node();
  }

  getCloud() {
    return cloud().canvas(() => createCanvas(this.width, this.height));
  }

  getCloudAsync() {
    return new Promise((resolve, reject) => {
      this.getCloud()
        .size([this.width, this.height])
        .words(this.phrases.slice(0, 40).map(function(d) {
          return {text: d.phrase, size: (d.importance * 3 + d.frequency) * 7};
        }))
        .spiral('archimedean')
        .padding(2)
        .rotate(function(d) {
          return d.text.length > 10 ? 0 : ~~(Math.random() * 2) * -90;
        })
        .font('Impact')
        .fontSize(function(d) {
          return d.size;
        })
        .on('end', (result: any) => resolve(result))
        .start();
    });
  }

  generateWordCloud() {
    const svgWords = this.getCloudAsync()
      .then((words) => {
        console.log(words);
        this.svg = this.draw(words);
        this.renderer.appendChild(this.el.nativeElement, this.svg);
      });
  }
}
